import { schema } from 'normalizr';

export const criterionSchema = new schema.Entity('criteria', {}, { idAttribute: '_id' });
export const criterionListSchema = [criterionSchema];
